<template>
    <div class="llp-input">
        <div :class="[{'position-relative d-inline-flex align-items-center' : showClearButton()}]" class="w-100">
            <input :id="id" :class="[{'border border-danger' : errors.length > 0}, classNames]" :disabled="disabled"
                   :maxlength="maxLength" :name="id"
                   :placeHolder="placeHolder" :type="inputType" :value="modelValue" class="form-control pe-4"
                   @change="touched = false; $emit('change:modelValue',  $event.target.value)"
                   @input="clearField($event); $emit('update:modelValue',  $event.target.value)">
                   <button v-if="showClearButton()"
                    aria-label="Clear input"
                    class="btn bg-transparent float-end d-flex p-2 position-absolute end-0"
                    type="button"
                    @click="$emit('update:modelValue', '')">
                <i class="fas fa-0 fa-xmark text-primary"></i>
            </button>
        
        </div>
        <span v-if="errors.length === 1" class="text-danger">
            {{ errors[0].$message }}
        </span>
        <ul v-else-if="errors.length > 1" class="m-0">
            <li v-for="error in errors" :key="error.$uid" class="text-danger">
                <span class="text-danger">{{ error.$message }}</span>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
  name: 'BaseInput',
  props: {
    id: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    modelValue: {
      type: [String, Number, null],
      required: true,
    },
    classNames: {
      type: String,
      required: false,
      default: '',
    },
    maxLength: {
      type: String,
      required: false,
      default: '100',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeHolder: {
      type: String,
      required: false,
      default: '',
    },
    errors: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    autoClear: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      model: this.modelValue,
      touched: false,
       showPassword: false,
    };
  },
    computed: {
    inputType() {
      return this.type === 'password' ? (this.showPassword ? 'text' : 'password') : this.type;
    },
  },
  methods: {
    
    clearField: function($event) {
      if (!this.autoClear || this.touched) return;

      // auto clear when the field is first touched or the input value is empty
      // it will be cleared and use the input value as the model data
      this.touched = true;
      $event.target.value = $event.data;
    },
    showClearButton: function() {
      // hide when the input field is disabled
      if (this.disabled) return false;

      // hide when the input field is number
      if (typeof this.modelValue === 'number') return false;

      // hide when input field is empty
      if (this.modelValue === '' || this.modelValue === null) return false;

      return true;
    },
     togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>
